import { stringify } from 'query-string';

export const constructUrl = ({
  baseURL,
  params,
  paramsToAddWithoutKeys,
}: {
  baseURL: string;
  params: Record<string, any>;
  paramsToAddWithoutKeys?: (string | undefined)[];
}): string => {
  let queryString = stringify(params, { skipNull: true });

  if (paramsToAddWithoutKeys) {
    paramsToAddWithoutKeys.forEach((value) => {
      if (value) {
        queryString += `&${value}`;
      }
    });
  }

  return `${baseURL}?${queryString}`;
};
